import { getUserTradingVolume } from "../../utils/apiClient";
import AppConstants from "../../utils/appConstants";

class UserTradingVolumeController {
  static async getVolumeSummary({
    accountType = 0,
    userId = null,
    dateFrom = null,
    dateTo = null,
  } = {}) {
    const response = await getUserTradingVolume({
      accountType,
      userId,
      dateFrom,
      dateTo,
    });

    const payload = response?.decryptedData || response?.data || {};
    const code = Number(payload.CODE ?? payload.code);
    if (code !== AppConstants.responseOk) {
      const msg =
        payload.MESSAGE ||
        payload.message ||
        payload.MESSAGES ||
        `API Error (CODE: ${code || "Unknown"})`;
      const error = new Error(typeof msg === "string" ? msg : "Failed to load trading volume");
      error.code = code;
      throw error;
    }

    const dataBlock = payload.DATA || payload.data || {};
    const total = Number(dataBlock.TOTAL_VOLUME ?? dataBlock.total_volume ?? 0);
    const rows = Array.isArray(dataBlock.ACCOUNTS)
      ? dataBlock.ACCOUNTS
      : Array.isArray(dataBlock.accounts)
        ? dataBlock.accounts
        : [];

    const byKey = {};
    rows.forEach((row) => {
      const volume = Number(row.VOLUME ?? row.volume ?? 0);
      const safeVolume = Number.isFinite(volume) ? volume : 0;
      const tradingId = row.TRADING_ID ?? row.trading_id;
      const accountId = row.ACCOUNT_ID ?? row.account_id ?? row.ID ?? row.id;
      if (tradingId != null && String(tradingId).trim() !== "") {
        byKey[String(tradingId)] = safeVolume;
      }
      if (accountId != null && String(accountId).trim() !== "") {
        byKey[String(accountId)] = safeVolume;
      }
    });

    return {
      total: Number.isFinite(total) ? total : 0,
      byKey,
    };
  }
}

export default UserTradingVolumeController;
